import { schemaNames } from '@app/bindx-schema'
import { SnapshotStore } from '@contember/bindx'
import { ContemberBindxProvider } from '@contember/bindx-react'
import { useCurrentContentGraphQlClient } from '@contember/react-client'
import { type ComponentProps, type ReactNode, useMemo } from 'react'

// Bindx data layer fed by the authenticated content client from the
// surrounding <ContemberClient> (NPI pattern). The session token sent by the
// SDK is a placeholder the worker proxy swaps for the real token from the
// CONTEMBER_TOKEN cookie.
//
// Schema: generated from the Contember model by `bun run bindx:generate`
// (`packages/bindx-schema/src`, decision 3 in cms-plan/01). Never hand-edit.
export function ContemberProvider({ children }: { children: ReactNode }) {
	const client = useCurrentContentGraphQlClient()
	const store = useMemo(() => new SnapshotStore(), [])
	const bindxClient = client as unknown as ComponentProps<typeof ContemberBindxProvider>['client']

	return (
		<ContemberBindxProvider client={bindxClient} schema={schemaNames} store={store}>
			{children}
		</ContemberBindxProvider>
	)
}
